import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { alertActions } from '../store/actions/alert.action';
import { alertConstants } from '../constants/alert.constants';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import SystemLabel from '../system/SystemLabel/SystemLabel';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class AlertDialog extends React.Component {
  getIcon = () => {
    const { type } = this.props.alert;
    switch (type) {
      case alertConstants.SUCCESS:
        return <CheckCircleIcon />
      case alertConstants.INFO:
        return <InfoIcon />
      case alertConstants.ERROR:
        return <ErrorIcon />
      case alertConstants.WARNING:
        return <WarningIcon />
      default:
        return null;
    }
  }
  handleClose = () => this.props.dispatch(alertActions.clear())
  render() {
    const { show, message, title } = this.props.alert;
    if (!show) return null;
    return (
      <div>
        <Dialog
          open={true}
          style={{ minWidth: 350 }}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">{this.getIcon()}{"   "}     <SystemLabel name={title} /></DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <SystemLabel name={message} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div >
    );
  }
}


function mapStateToProps(state) {
  return {
    alert: state.alert
  };
}
export default connect(mapStateToProps)(AlertDialog);